import styled, { css } from 'styled-components';

import { TextButton } from '@xing-com/button';
import { PopOver as BreweryPopOver } from '@xing-com/pop-over';
import { spaceXS, spaceXXL, xdlColorLink } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

const TextWrapper = styled.div<{ center?: boolean }>`
  margin-bottom: ${spaceXXL};

  ${({ center }) =>
    center &&
    css`
      text-align: center;
    `}
`;

const PopOver = styled(BreweryPopOver)`
  left: 50%;
  transform: translateX(-50%);
`;

const ResendWrapper = styled(BodyCopy)`
  display: inline-flex;
  align-items: center;
`;

const ResendButton = styled(TextButton)`
  text-decoration: underline;
  color: ${xdlColorLink};
  margin-left: ${spaceXS};
`;

export const Styled = {
  TextWrapper,
  PopOver,
  ResendWrapper,
  ResendButton,
};
